import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=2a21bf58&scoped=true&"
import script from "./Exam.vue?vue&type=script&lang=js&"
export * from "./Exam.vue?vue&type=script&lang=js&"
import style0 from "./Exam.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Exam.vue?vue&type=style&index=1&id=2a21bf58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21bf58",
  null
  
)

export default component.exports